import _Input from "antd/es/input";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import OneTextArea from '../OneTextarea';
import cs from 'classnames';
import './index.less';
/**
 * import { OneInput } from '@yy/one-ui'
 */
var OneInput = function OneInput(props) {
  return /*#__PURE__*/React.createElement(_Input, _extends({}, props, {
    className: cs('one-input', props.className)
  }));
};
var Search = function Search(props) {
  return /*#__PURE__*/React.createElement(_Input.Search, _extends({}, props, {
    className: cs('one-input-search', props.className)
  }));
};
export var isChinese = function isChinese(str) {
  var reg = /[u00-uFF]/;
  return !reg.test(str);
};
export var calcCharacterlen = function calcCharacterlen(str) {
  if (!str) return 0;
  var strlength = 0;
  for (var i = 0; i < str.length; ++i) {
    if (isChinese(str.charAt(i)) == true) strlength = strlength + 2;
    //中文计算为一个字符
    else strlength = strlength + 1;
  }
  return strlength;
};
OneInput.Group = _Input.Group;
OneInput.Search = Search;
OneInput.OneTextArea = OneTextArea;
OneInput.TextArea = _Input.TextArea;
OneInput.Password = _Input.Password;
export default OneInput;